// Migrado a Material UI v5 con diseño mejorado y visualización de documentos en Card
import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProgramarMto.css';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  FormHelperText,
  Select,
  InputLabel,
  CircularProgress,
  Grid,
  Typography,
  Link,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Tooltip,
  Divider
} from '@mui/material';
import { useDropzone } from 'react-dropzone';

import {
  FaArrowLeft,
  FaPlus,
  FaCheck,
  FaCheckCircle,
  FaPaperclip,
  FaFilePdf
} from 'react-icons/fa';

import { clearErrors, subirDocumento, getEquipo } from '../../../redux/actions/dataactions';

function AdjuntarDoc(props) {
  const [open, setOpen] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState('');

  const { loading, errors, aprobado } = props.UI;

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1
  });

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    if (aprobado) props.getEquipo(props.equipoId);
    setOpen(false);
  };

  const handleChange = (e) => setTipoDocumento(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!acceptedFiles.length || !tipoDocumento) return;
    const formData = new FormData();
    formData.append("documento", acceptedFiles[0]);
    formData.append("tipoDocumento", tipoDocumento);
    props.subirDocumento(formData, props.clienteId, props.equipoId, props.user.credentials.handle);
  };

  const documentos = [
    { key: 'urlmanual', label: 'Manual de Usuario' },
    { key: 'urlfactura', label: 'Factura' },
    { key: 'urlmanualservice', label: 'Manual de Servicio' },
    { key: 'urlimportacion', label: 'Declaración de Importación' },
    { key: 'urlregistroinvima', label: 'Registro INVIMA' },
    { key: 'urlactadeentrega', label: 'Acta de Entrega' },
    { key: 'urlcontratoalquiler', label: 'Contrato de Alquiler' },
    { key: 'urlcontratocomodato', label: 'Contrato Comodato' }
  ];

  return (
    <Fragment>
      <Tooltip title="Adjuntar Documentos">
        <IconButton onClick={handleOpen}>
          <FaPaperclip color="#03178C" className="icon-crearcliente" />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle><Typography sx={{ 
                                          fontSize: '20px', 
                                          fontWeight: 400, 
                                          color: '#0468BF', 
                                          textAlign: 'center' 
                                          }}>
                                          Adjuntar Documentos
                          </Typography></DialogTitle>

        {aprobado ? (
          <DialogContent>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <Grid item>
                <FaCheck size={40} color="#20B90C" />
              </Grid>
              <Grid item>
                <Typography variant="h6" color="success.main">¡Documento Adjuntado Exitosamente!</Typography>
              </Grid>
            </Grid>
          </DialogContent>
        ) : (
          <DialogContent>
            {props.equipo && (
              <>
                <Typography  sx={{ 
                                          fontSize: '20px', 
                                          fontWeight: 400, 
                                          color: '#0468BF', 
                                          textAlign: 'start' 
                                          }}  gutterBottom>Documentos Adjuntos:</Typography>
                <Grid container spacing={2}>
                  {documentos.map(doc => (
                    props.equipo[doc.key] && (
                      <Grid item xs={12} sm={6} key={doc.key}>
                        <Card variant="outlined">
                          <CardContent>
                            <Grid container alignItems="center" spacing={1}>
                              <Grid item>
                                <FaFilePdf color="#03178C" />
                              </Grid>
                              <Grid item xs>
                                <Typography variant="body1">
                                  <Link href={props.equipo[doc.key]} target="_blank" rel="noopener">
                                    {doc.label}
                                  </Link>
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  ))}
                </Grid>
                <Divider className="my-2" />
              </>
            )}

            <form onSubmit={handleSubmit}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo de Documento</InputLabel>
                <Select name="tipoDocumento" value={tipoDocumento} onChange={handleChange} required>
                  <MenuItem value=""><em>Seleccione</em></MenuItem>
                  {documentos.map(doc => (
                    <MenuItem key={doc.key} value={doc.key.replace('url', '')}>{doc.label}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors?.tipoDocumento}</FormHelperText>
              </FormControl>

              <div {...getRootProps({ className: 'dropzone mt-3' })}>
                <input {...getInputProps()} />
                <Typography variant="body2">Arrastra el archivo aquí, o haz clic para seleccionarlo</Typography>
                <em>(Formatos permitidos: PDF, DOC, DOCX)</em>
              </div>

              {fileRejections.length > 0 && <Typography color="error">Solo se permite subir un archivo</Typography>}
              {acceptedFiles.length > 0 && (
                <ul>
                  {acceptedFiles.map(file => (
                    <li key={file.path}>{file.path} - {file.size} bytes</li>
                  ))}
                </ul>
              )}

              {errors?.errors?.length > 0 && (
                <ul>
                  {errors.errors.map((err, idx) => (
                    <li key={idx} style={{ color: 'red' }}>{err}</li>
                  ))}
                </ul>
              )}
            </form>
          </DialogContent>
        )}

        <DialogActions>
          <Tooltip title="Cerrar">
            <IconButton onClick={handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </IconButton>
          </Tooltip>

          {loading ? (
            <CircularProgress size={30} color="primary" />
          ) : aprobado ? (
            <Tooltip title="Continuar">
              <IconButton onClick={handleClose}>
                <FaCheckCircle color="#20B90C" className="icon-formulario" />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Subir Documento">
              <IconButton onClick={handleSubmit}>
                <FaPlus color="#03178C" className="icon-formulario" />
              </IconButton>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

AdjuntarDoc.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  subirDocumento: PropTypes.func.isRequired,
  getEquipo: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  equipoId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  user: state.user,
  equipo: state.data.equipo.credentials
});

export default connect(mapStateToProps, { clearErrors, subirDocumento, getEquipo })(AdjuntarDoc);
